document.addEventListener("DOMContentLoaded", function () {
    const excludedPages = ["/", "/pages/navidad", "/pages/juguetes"];
    const currentPath = window.location.pathname;

    const isExcluded = excludedPages.includes(currentPath);

    if (!isExcluded) {
        const widget = document.querySelector("#raxm-widget");
        if (widget) {
            widget.remove();
        }
    }
});